$(document).ready(function() {    
    var nav = $('header .mobile nav');       
    nav.append($('header .desctop nav > ul').clone());
     
    var openBtn = $('.sandwich');
    openBtn.click(function(){
        if(openBtn.is('.active')) {
            openBtn.removeClass('active');
            nav.slideUp();
        }
        else {
            openBtn.addClass('active');
            nav.slideDown();
        }
    });
    
    nav.find('> ul > li > a').click(function(event) {        
        nav.find('> ul > li > ul').hide();
        
        var submenu = $(this).closest('li').find('ul'); 
        if(submenu.length > 0) {
            event.preventDefault();
            
            if(submenu.is(':visible')) {
                submenu.slideUp();
            }
            else {
                submenu.slideDown();
            }                  
        }
        else {
            
        }
        
    });
});